import React, { useState, useEffect } from 'react';
import { Container, LinearProgress } from '@mui/material';

import HierarchyListing from 'ui/HierarchyListing';
import { useQueryString } from 'hooks/useQueryString';
import { CatalogService } from 'api/catalog/services';
import { IDepartments } from 'api/catalog/models';
import NoResults from 'ui/ErrorDisplay/NoResults';
import ServiceError from 'ui/ErrorDisplay/ServiceError';
import PageWrapper from 'ui/PageWrapper';

const PageCategories = () => {
  const { parsedQueryString } = useQueryString();

  const [departments, setDepartments] = useState<IDepartments>();
  const [isDepartmentsLoading, setIsDepartmentsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsDepartmentsLoading(true);
    setIsError(false);
    CatalogService.getDepartments({ ...parsedQueryString })
      .then((res) => {
        setDepartments(res.data);
      })
      .catch((err) => {
        setIsError(true);
        console.warn('err: ', err);
      })
      .finally(() => {
        setIsDepartmentsLoading(false);
      });
  }, [parsedQueryString]);
  return (
    <PageWrapper>
      {isDepartmentsLoading ? (
        <LinearProgress sx={{ width: '100%' }} />
      ) : isError ? (
        <ServiceError />
      ) : !departments?.departments?.length ? (
        <NoResults />
      ) : (
        <Container maxWidth='xl'>
          {departments.departments.map((dept) => (
            <HierarchyListing isOpen key={dept.name} hierarchy={dept} />
          ))}
        </Container>
      )}
    </PageWrapper>
  );
};

export default PageCategories;
